import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './DashboardTabs.css';

const DashboardTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div>
      <div className="tabs">
        <button
          className={location.pathname === '/DashboardCard' ? 'active' : ''}
          onClick={() => navigate('/DashboardCard')}
        >
          Resumo de Ambientes
        </button>
        <button
          className={location.pathname === '/DashboardAmbiente' ? 'active' : ''}
          onClick={() => navigate('/DashboardAmbiente')}
        >
          Ambientes
        </button>
        <button
          className={location.pathname === '/Dashboard' ? 'active' : ''}
          onClick={() => navigate('/Dashboard')}
        >
          Geladeiras
        </button>
      </div>
    </div>
  );
};

export default DashboardTabs;
